import mlfApi from '@mlfcore/api/init'
// import dataverseApi from '@mlfcore/api/init'
import axios from '@axios'

const { api } = mlfApi(axios, {})
export default api

// const { dataverseApi } = dataverseApi(axios)
// export default dataverseApi
